import script from "./EntityFieldRow.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityFieldRow.vue?vue&type=script&setup=true&lang=js"

import "./EntityFieldRow.vue?vue&type=style&index=0&id=58f3df2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58f3df2c"]])

export default __exports__